<template>
  <header class="heads" :class="[menuopen ? 'open' : '', curLang !== 'zh_CN' ? 'english-layout' : '']">
    <div class="w1440 cf relative">
      <div class="logo" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''"><router-link to="/"><img :src="globalDataArray.siteInfo.logoHead" alt=""></router-link></div>

      <div class="mainMenuMask" @click="mianMenuFun"></div>
      <div class="mobileMenu" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
        <div class="mainMenu fnt_20">
          <div class="itemBox" v-for="(item,index) in globalDataArray.siteNavigation" :key="'item' + index" v-if="item.linkUrl !== '/more'">
            <router-link class="item" :to="item.linkUrl" :class="{ 'cur': isNavItemActive(item.linkUrl) }">
              {{ item.title }}
            </router-link>
          </div>
        </div>

        <div class="searchLanLogin">
          <div class="cf">
            <div class="fl fll">
              <div class="searchArea">
                <div class="btn"><router-link to="/search" /></div>
              </div>
            </div>
            <div class="fl fll">
              <div class="switchLan fl">
                <a-select v-model="curLang" @change="switchLangFun" style="width: 69px;">
                  <a-select-option v-for="item in globalDataArray.siteLanguage" :key="item.value">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </div>
            </div>

            <div v-if="isClient && islogin" class="myMsgBtn fl" @click="toMymsgFun"> <span v-if="msgnum && msgnum>0">{{ msgnum }}</span> </div>

            <div class="fl logoutBtn fll">
              <a-dropdown v-if="isClient && islogin">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                  {{ displayUserName }} <a-icon type="down" />
                </a>
                <a-menu slot="overlay" @click="loginoutFun">
                  <a-menu-item key="1">{{ globalDataArray.siteTemplateLanguage.person_user_center }}</a-menu-item>
                  <a-menu-item key="2">{{ globalDataArray.siteTemplateLanguage.login_out }}</a-menu-item>
                </a-menu>
              </a-dropdown>
              <!-- <div  class="loginBtn fnt_16"><router-link to="/myrecord">{{globalDataArray.siteTemplateLanguage.btn_person_center}}</router-link></div> -->

              <div v-else-if="isClient" class="loginBtn fnt_16" @click="handleLogin">{{ globalDataArray.siteTemplateLanguage.btn_login_register }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobileMenuBtn" @click="mianMenuFun"></div>
    </div>

    <!-- 老用户确认服务协议 -->
    <olduserxieyi :olduserxieyi.sync="olduserxieyi" @itemclick="olduserxieyiCallback" />
  </header>
</template>

<script>
import Cookies from 'js-cookie'
import { message } from 'ant-design-vue'
import { login, loginout } from '@/api/login/login'
export default {
  name: 'Heads',
  data() {
    return {
      isSelect: '/home',
      menuopen: false,
      islogin: false,
      isClient: false, // 客户端标识，确保SSR水合一致性
      curLang: this.getInitialLanguage(), // SSR兼容：统一初始语言值
      curUserName: '',
      olduserxieyi: false // 老用户协议
    }
  },
  watch: {
    $route(to, from) {
      if (this.menuopen) {
        // 监听路由变化关闭弹层
        this.menuopen = false
      }
    }
  },
  computed: {
    msgnum() {
      return this.$store.state.msgnum
    },
    // 处理用户名显示逻辑
    displayUserName() {
      if (!this.curUserName) return ''

      // 判断是否为中文状态
      const isChinese = this.curLang === 'zh_CN'

      if (isChinese) {
        // 中文状态：超过7个字符时，左右各显示一个字，中间用4个星号代替
        if (this.curUserName.length > 7) {
          return this.curUserName.charAt(0) + '****' + this.curUserName.charAt(this.curUserName.length - 1)
        }
      } else {
        // 英文状态：超过4个字母时，左右各显示一个字母，中间用2个星号代替
        if (this.curUserName.length > 4) {
          return this.curUserName.charAt(0) + '**' + this.curUserName.charAt(this.curUserName.length - 1)
        }
      }

      return this.curUserName
    }
  },
  created() {
    const that = this
    const atomUser = Cookies.get('atom_user')// 获取atom的cookie值
    const saiti_access_info = Cookies.get('saiti_access_info')
    // if (atomUser!=null && atomUser!=undefined){
    // Cookies.remove('atom_user',{domain:'.openatom.tech',path: '/'});
    // if (saiti_access_info==null || saiti_access_info==undefined || saiti_access_info =='') {
    that.checkLogin()
    // }
    // }

    // let curToken=Cookies.get('saiti_access_info')
    // if (curToken!=null && curToken!=undefined) {
    //   let saiti_access_info=JSON.parse(curToken)
    //   that.islogin=true
    //   if(saiti_access_info.nickname!=''&&saiti_access_info.nickname!=null&&saiti_access_info.nickname!=undefined){
    //     that.curUserName=saiti_access_info.nickname
    //   }else{
    //     that.curUserName=saiti_access_info.username
    //   }
    // }
  },

  mounted() {
    const that = this

    // 设置客户端状态，确保SSR水合一致性
    that.isClient = true

    that.isSelect = that.$route.path

    // let token= Cookies.get("ATOMGIT_ACCESS_TOKEN");
    // console.log(token,"gt")
    // if (token!=null && token!=undefined){
    //   that.islogin=true
    // }

    // 在下个tick中更新语言，避免SSR水合不匹配
    that.$nextTick(() => {
      const currentLanguge = Cookies.get('DEFAULT_LANG')
      if (currentLanguge != null && currentLanguge != undefined && currentLanguge != '') {
        that.curLang = currentLanguge
      } else {
        that.curLang = that.globalDataArray.siteLanguage[0].value
      }
    })
  },
  methods: {
    // 判断导航项是否激活
    isNavItemActive(linkUrl) {
      const currentPath = this.$route.path
      const currentQuery = this.$route.query

      // 对于专区导航项的特殊处理
      if (linkUrl === '/zone') {
        // 如果当前路径是 /zone，直接激活
        if (currentPath === '/zone') {
          return true
        }
        // 如果当前路径是 /competition 且包含 zone_id 参数，也要激活专区导航
        if (currentPath === '/competition' && currentQuery.zone_id) {
          return true
        }
        // 如果当前路径是赛题详情页且包含 zone_id 参数，也要激活专区导航
        if (currentPath.startsWith('/competitionInfo') && currentQuery.zone_id) {
          return true
        }
        return false
      }

      // 对于赛题导航项的特殊处理
      if (linkUrl === '/competition') {
        // 如果当前路径是 /competition 但包含 zone_id 参数，不激活赛题导航（应该激活专区导航）
        if (currentPath === '/competition' && currentQuery.zone_id) {
          return false
        }
        // 如果当前路径是赛题详情页但包含 zone_id 参数，不激活赛题导航（应该激活专区导航）
        if (currentPath.startsWith('/competitionInfo') && currentQuery.zone_id) {
          return false
        }
        // 如果当前路径是 /competition 或赛题详情页，激活赛题导航
        if (currentPath === '/competition' || currentPath.startsWith('/competitionInfo')) {
          return true
        }
        return false
      }

      // 对于其他导航项，使用精确匹配
      return currentPath === linkUrl
    },

    // 获取初始语言值，确保SSR水合一致性
    getInitialLanguage() {
      // 服务端环境无法访问Cookie，返回安全默认值
      if (this.$isServer) {
        return this.globalDataArray?.siteLanguage?.[0]?.value || 'zh_CN'
      }

      // 客户端环境也先返回默认值，避免水合不匹配
      // 实际语言切换在mounted中进行
      return this.globalDataArray?.siteLanguage?.[0]?.value || 'zh_CN'
    },

    mianMenuFun() {
      const that = this
      that.menuopen = !that.menuopen
    },

    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.openatom.tech', expires: 180, path: '/', secure: true })
      location.href = this.logAuthUrl
    },

    checkLogin() {
      const that = this
      login({}).then(res => {
        // console.log(res)
        if (res.success) {
          // console.log(res)
          const result = JSON.stringify(res.result)
          Cookies.set('saiti_access_info', result, { domain: process.env.NODE_ENV === 'production' ? '.openatom.tech' : undefined, expires: 180, path: '/', secure: process.env.NODE_ENV === 'production' })
          that.islogin = true

          if (res.result.nickname != '' && res.result.nickname != null && res.result.nickname != undefined) {
            that.curUserName = res.result.nickname
          } else {
            that.curUserName = res.result.username
          }
          // that.msgnum=res.result.noReadMsg
          this.$store.commit('setSiteMsgnum', res.result.noReadMsg)
          this.olduserxieyiFun()
          // location.reload()
          // message.success(that.globalDataArray.siteTemplateLanguage.member_login_success_tips)
        } else {
          const saiti_access_info = Cookies.get('saiti_access_info')
          if (saiti_access_info != null && saiti_access_info != undefined && saiti_access_info != '') {
            Cookies.remove('saiti_access_info', { domain: process.env.NODE_ENV === 'production' ? '.openatom.tech' : undefined, path: '/' })
            that.islogin = false
          }
        }
      })
    },
    switchLangFun(e) {
      const that = this
      // console.log(e)
      const curlang = e
      const sitelang = that.globalDataArray.siteInfo.identification
      console.log('当前环境', process.env.NODE_ENV)
      Cookies.set('DEFAULT_LANG', curlang, { domain: process.env.NODE_ENV === 'production' ? '.openatom.tech' : undefined, expires: 180, path: '/', secure: process.env.NODE_ENV === 'production' })
      Cookies.set('attr_lang', sitelang, { domain: process.env.NODE_ENV === 'production' ? '.openatom.tech' : undefined, expires: 180, path: '/', secure: process.env.NODE_ENV === 'production' })
      // Cookies.set('DEFAULT_LANG', curlang, { domain: '.openatom.tech', expires: 180, path: '/', secure: false })
      // Cookies.set('attr_lang', sitelang, { domain: '.openatom.tech', expires: 180, path: '/', secure: false })
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          window.location.reload()
        }
      }, 100)
    },

    loginoutFun(e) {
      const that = this
      // console.log(e)
      if (e.key == '2') {
        // 退出登录
        const curmeta = that.$router.currentRoute.meta
        loginout({}).then(res => {
          if (res.success) {
            Cookies.remove('saiti_access_info', { domain: process.env.NODE_ENV === 'production' ? '.openatom.tech' : undefined, path: '/' })
            that.islogin = false

            const logoutUrl = that.logoutApiUrl + '?redirect_uri=' + encodeURIComponent(location.href)
            location.href = logoutUrl
          } else {
            message.error(res.message)
          }
        })
      } else {
        that.$router.push({ path: '/mypersonal' })
      }
    },

    toMymsgFun() {
      this.$router.push({ path: '/mymessage' })
    },
    // 是否开启老用户协议展示
    olduserxieyiFun() {
      let token = ''
      let info = {}
      const saitiAccessInfo = Cookies.get('saiti_access_info')
      if (saitiAccessInfo != '' && saitiAccessInfo != undefined && saitiAccessInfo != null) {
        token = JSON.parse(saitiAccessInfo).token
        info = JSON.parse(saitiAccessInfo)

        if (token != '' && token != undefined && info.isAgree == 0 && info.isAgree != null) {
          this.olduserxieyi = true
        }
      }
      // console.log(token)
    },
    olduserxieyiCallback(res) {
      // console.log(res)
    }

  }
}
</script>
<style scoped lang="scss">
.custom-margin-horizontal {
  margin: 0 24px;
}

// 英文状态下的样式
.heads.english-layout {
  .loginBtn {
    padding: 0 1em !important;
    line-height: 35px !important;
    border-radius: 20px !important;
  }

  .fnt_16 {
    font-size: 11px !important;
  }

  .searchLanLogin .cf {
    display: flex;
    align-items: center;
  }

  .fll {
    margin: 0 0 0 -6px;
    float: none !important;
  }

  .searchArea {
    margin-top: 0 !important;
  }

  .myMsgBtn {
    width: 18px !important;
    height: 18px !important;
    margin-top: 0 !important;
    margin-right: 1.5em !important;
  }
}
</style>
